/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_seo_sg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL slug generator`)
};

const es_home_seo_sg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de slug de URL`)
};

const de_home_seo_sg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL-Slug-Generator`)
};

const nl_home_seo_sg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL slug generator`)
};

const fr_home_seo_sg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de slug URL`)
};

const it_home_seo_sg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di slug URL`)
};

const pt_br2_home_seo_sg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de slug de URL`)
};

const pt_home_seo_sg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de slugs de URL`)
};

const ja_home_seo_sg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URLスラグジェネレータ`)
};

const zh_home_seo_sg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL Slug 生成器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_seo_sg_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_seo_sg_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_seo_sg_title", locale)
	if (locale === "en") return en_home_seo_sg_title(inputs)
	if (locale === "es") return es_home_seo_sg_title(inputs)
	if (locale === "de") return de_home_seo_sg_title(inputs)
	if (locale === "nl") return nl_home_seo_sg_title(inputs)
	if (locale === "fr") return fr_home_seo_sg_title(inputs)
	if (locale === "it") return it_home_seo_sg_title(inputs)
	if (locale === "pt-BR") return pt_br2_home_seo_sg_title(inputs)
	if (locale === "pt") return pt_home_seo_sg_title(inputs)
	if (locale === "ja") return ja_home_seo_sg_title(inputs)
	return zh_home_seo_sg_title(inputs)
};